
import Vue from "vue";
import axiosBase from "axios";
import { getLocaleForLegalDocuments } from "@/lib/utils/i18n/locale";

// microCMS APIのレスポンス型定義
interface MicroCMSPrivacyContent {
  id: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  revisedAt: string;
  type: string[];
  html: string;
  locale: string[];
}

interface MicroCMSResponse {
  contents: MicroCMSPrivacyContent[];
}

// axiosインスタンスの作成
const axios = axiosBase.create({
  baseURL: process.env.VUE_APP_MICROCMS_API_ENDPOINT,
  headers: { "X-API-KEY": process.env.VUE_APP_MICROCMS_API_KEY },
});

export default Vue.extend({
  // NOTE: metaタグの設定
  metaInfo() {
    if (process.env.NODE_ENV === "production") {
      return {};
    }
    return {
      meta: [
        {
          name: "robots",
          content: "none",
        },
      ],
    };
  },
  data() {
    return {
      isLoading: true,
      error: null as string | null,
      privacyContent: null as string | null,
    };
  },
  async created() {
    await this.fetchPrivacyContent();
  },
  methods: {
    async fetchPrivacyContent() {
      try {
        this.isLoading = true;
        this.error = null;

        // プライバシーポリシー用のロケールを取得（Intl APIを使用）
        const microCMSLocale = getLocaleForLegalDocuments();

        // フィルターを構築
        const localeFilter = `type[contains]privacy[and]locale[contains]${microCMSLocale}`;

        // microCMSからプライバシーポリシーを取得
        // type=privacyとlocaleで絞り込んで取得
        const privacyRequest = await axios.get<MicroCMSResponse>(`/docs?filters=${localeFilter}`);

        if (privacyRequest.status !== 200) {
          throw new Error("Failed to fetch privacy policy");
        }

        const responseData = privacyRequest.data;

        // データの存在確認とバリデーション
        if (!responseData?.contents || !Array.isArray(responseData.contents) || responseData.contents.length === 0) {
          throw new Error("Privacy policy data not found");
        }

        // 最初のコンテンツを取得
        const privacy = responseData.contents[0];

        if (!privacy?.html) {
          throw new Error("Privacy policy HTML content not found");
        }

        // microCMSから取得したHTMLをそのまま設定
        this.privacyContent = privacy.html;
      } catch (error) {
        console.error("Failed to fetch privacy content:", error);
        this.error = error instanceof Error ? error.message : "An unknown error occurred";
      } finally {
        this.isLoading = false;
      }
    },
  },
});
